export const navLinks = [
    {
        id: 1,
        title: 'Home',
        link: '/'
    }
    , {
        id: 2,
        title: 'About Us',
        link: '/about'
    }
    , {
        id: 3,
        title: 'What We Build',
        link: '/what-we-build'
    }
    , {
        id: 4,
        title: 'Quick Move-In',
        link: '/move-in'
    }
    , {
        id: 5,
        title: 'Contact Us',
        link: '/contact'
    }
];

export const webName = 'LYD Housing';

// export const EstatesCard = [
    // {
    //     id: 1,
    //     imgUrl: "https://res.cloudinary.com/dtivafy25/image/upload/v1720182494/img-1_asuirm.svg",
    //     title: 'The Residence',
    //     subTitle: 'Coming Soon in...',
    //     // propertySummary: 'Open Floor Plan with 5 Bedrooms and a Loft',
    //     propertyAddress: 'PA 17050, Highly Rated C.V School District',
    //     price: 'Priced at $618,100',
    //     home: '2 Stories',
    //     bed: '4 Beds',
    //     bath: '4 Baths',
    //     garages: '2 Garages',
    //     sq: '3335 Sq. Ft',
    // },
    // {
    //     id: 2,
    //     imgUrl: 'https://res.cloudinary.com/dtivafy25/image/upload/v1720182504/img-2_ysb6cn.svg',
    //     title: 'The Villa',
    //     // subTitle: 'Mountain View Estates',
    //     // propertySummary: 'Open Floor Plan with 5 Bedrooms and a Loft',
    //     propertyAddress: '53, Cumberland Estate Drive, Mechanicsburg P.A, 17050, USA',
    //     price: 'Priced at $618,100',
    //     home: '2 Stories',
    //     bed: '4 Bedrooms',
    //     bath: '4½ Baths',
    //     garages: '2 Garages',
    //     sq: '5000 Sq. Ft',
    // },

    // {
    //     id: 1,
    //     imgUrl:
    //         "residence.webp",
    //     title: "The Residence",
    //     subTitle: "Coming Soon",
    //     propertyAddress:
    //         "Country Club Road, Camphill, PA - 17011, USA",
    //     price: "Coming Soon",
    //     home: "2 Stories",
    //     bed: "4 Bedrooms",
    //     bath: "3½ Baths",
    //     garages: "2 Garages",
    //     sq: "Luxury Estate",
    //     living: "2 Living Areas",
    //     extra: "2 Storage Rooms",
    //     patio: "Covered Patio",
    //     basement: "Finished Basement",
    // },
    // {
    //     id: 2,
    //     imgUrl:
    //         "villa.webp",
    //     title: "The Villa",
    //     subTitle: "Luxury Estate",
    //     propertyAddress:
    //         "53 Cumberland Estate Drive, Mechanicsburg, PA - 17050, USA",
    //     price: "Priced at $1.6 Million",
    //     home: "2 Stories",
    //     bed: "4 Bedrooms",
    //     bath: "3½ Baths",
    //     garages: "2 Garages",
    //     sq: "About 5000 Sq. Ft",
    //     study: "1 Study / Office Room",
    //     sunroom: "Big Living Sun Room",
    //     deck: "Surround Deck",
    //     basement: "Fully Finished Basement",
    // },
    
    // {
    //     id: 3,
    //     imgUrl: 'https://res.cloudinary.com/dtivafy25/image/upload/v1722596346/the_manor_fz6mos.png',
    //     title: 'The Manor',
    //     subTitle: 'Mountain View Estates',
    //     // propertySummary: 'Open Floor Plan with 5 Bedrooms and a Loft',
    //     propertyAddress: '3833 Derry Street, Harrisburg, PA 17001',
    //     price: 'Priced at $618,100',
    //     home: '2 Stories',
    //     bed: '4 Beds',
    //     bath: '4 Baths',
    //     garages: '2 Garages',
    //     sq: '3335 Sq. Ft',
    // }
// ];

export const EstatesCard = [
    {
        id: 1,
        imgUrl: "residence.webp",
        title: "The Residence",
        subTitle: "Luxury Estate",
        propertyAddress:
            "53 Cumberland Estate Drive, Mechanicsburg, PA - 17050, USA",
        price: "1.6 Million",
        home: "2 Stories",
        bed: "4 Bedrooms",
        study: "1 Study / Office Room",
        bath: "3½ Baths",
        garages: "2 Garages",
        sunroom: "Big Living Sun Room",
        deck: "Surround Deck",
        basement: "Fully Finished Basement",
        sq: "About 5000 Sq. Ft",

    },

    {
        id: 2,
        imgUrl: "villa.webp",
        title: "The Villa",
        subTitle: "Coming Soon",
        propertyAddress:
            "Country Club Road, Camphill, PA - 17011, USA",
        price: "Coming Soon",
        home: "2 Stories",
        bed: "4 Bedrooms",
        living: "2 Living Areas",
        bath: "3½ Baths",
        extra: "2 Storage Rooms",
        patio: "Covered Patio",
        basement: "Finished Basement",
        garages: "2 Garages",
        sq: " About 4500 Sq. Ft",
    },
];